import { saveSessionValue } from "../../utilities/localStore/calls";
import { GetMyTeamMembers } from "./Enquiries";

export const getTeamsMembers: () => Promise<{ name: string; id: number }[]> = async () => {
    // This function would ideally make an API call to fetch the team members based on the team ID or user ID.
    // For demonstration purposes, we are using a static list defined above.
    const resp = await GetMyTeamMembers();
    if (resp.isOk && resp.data) {
        let teamList = resp.data.users.map(u => ({ name: u.name, id: u.id }));
        teamList = teamList.sort((a, b) => a.name.localeCompare(b.name));
        teamList.unshift({ name: "Select a user", id: 0 });
        saveSessionValue("myTeamsUserList", teamList);
        return teamList;
    } else {
        return [];
    }
};
